<!-- 医疗左侧导航链接 -->
<template>
  <div class="aside">
    <h3>
      <img src="@/assets/submenu01.png" />
    </h3>
    <el-menu :default-active="asideActiveindex" class="el-menu-vertical-demo" active-text-color="#f00" :router="true">
      <el-menu-item :index="menu[0].case" @click="setactive(menu[0].case)">
        <span slot="title">医院绩效管理解决方案</span>
      </el-menu-item>
      <el-menu-item :index="menu[1].case" @click="setactive(menu[1].case)">
        <span slot="title">医院精细化数据分析平台</span>
      </el-menu-item>
      <el-menu-item :index="menu[2].case" @click="setactive(menu[2].case)">
        <span slot="title">医院全成本核算解决方案</span>
      </el-menu-item>
      <el-menu-item :index="menu[3].case" @click="setactive(menu[3].case)">
        <span slot="title">医院全面预算解决方案</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>
<script>
import bus from '@/util/bus'
export default {
  //import引入的组件需要注入到对象中才能使用
  data() {
    //这里存放数据
    return {
      asideActiveindex: '',
      menu: [
        { case: '/hospital/case05' },
        { case: '/hospital/case06' },
        { case: '/hospital/case07' },
        { case: '/hospital/case08' }
      ]
    }
  },
  watch: {
    $route(to, from) {
      this.asideActiveindex = to.path
      console.log(from)
    }
  },
  methods: {
    setactive(index) {
      window.sessionStorage.setItem('activePath', index)
    },
    getActivepath() {
      const activeindex = window.sessionStorage.getItem('activePath')
      if (activeindex) {
        this.asideActiveindex = activeindex
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getActivepath()
  },

  mounted() {
    let _this = this
    bus.$on('setActivePath', function (activePath) {
      _this.activeindex = activePath
      console.log(_this.activeindex)
    })
  }
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.aside {
  width: 239px;
  float: left;
  .el-menu {
    border: none;
    background: #f7f7f7;
    .el-menu-item {
      font-size: 16px;
    }
    .el-menu-item.is-active {
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>
